import {createContext, use, useMemo, type ReactNode} from 'react'

interface IntentDetectionEnabledContextValue {
  isUsingIntentDetection: boolean
}

const IntentDetectionEnabledContext = createContext<IntentDetectionEnabledContextValue>({
  isUsingIntentDetection: false,
})

interface IntentDetectionEnabledProviderProps {
  isUsingIntentDetection: boolean
  children: ReactNode
}

export function IntentDetectionEnabledProvider({
  isUsingIntentDetection,
  children,
}: IntentDetectionEnabledProviderProps) {
  const value = useMemo(() => ({isUsingIntentDetection}), [isUsingIntentDetection])
  return <IntentDetectionEnabledContext value={value}>{children}</IntentDetectionEnabledContext>
}

export function useIntentDetectionEnabled(): IntentDetectionEnabledContextValue {
  return use(IntentDetectionEnabledContext)
}
